__turbopack_context__.v({
  "feedback": "style-module-scss-module__348Cpa__feedback",
});
